import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import {
  fetchConsentLetters,
  fetchUpperBlepharoplasty,
  fetchUpperBlepharoplastyBanner,
} from "../../api/SurgicalDomainApi";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";

const UpperBlepharoplasty = () => {
  const { setLoading } = useLoader();
  const [upperBlepharoplastyBanner, setUpperBlepharoplastyBanner] = useState<
    IBannerData[]
  >([]);
  const [upperBlepharoplastyData, setUpperBlepharoplastyData] = useState<
    ISurgicalData[]
  >([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchUpperBlepharoplastyBanner(),
      fetchUpperBlepharoplasty(),
      fetchConsentLetters(),
    ])
      .then(
        ([
          upperBlepharoplastyBannerData,
          upperBlepharoplastyData,
          consentLettersData,
        ]) => {
          setUpperBlepharoplastyBanner(upperBlepharoplastyBannerData);
          setUpperBlepharoplastyData(upperBlepharoplastyData);
          setConsentLetters(consentLettersData);
          // setArchiveVideoData(videoData);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        }
      )
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={upperBlepharoplastyBanner}
        page={"Upper Blepharoplasty"}
      />
      <SurgicalDomainsDescription descriptionData={upperBlepharoplastyData} consentLetters={consentLetters} surgicalName='Upper_Blepharoplasty'/>
    </>
  );
};

export default UpperBlepharoplasty;
